/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * "TỦ GẦN NHẤT" — một định nghĩa, cho mọi chỗ hỏi. (`GD-02`.)
 *
 * 🔴 VÌ SAO MỘT TỆP RIÊNG CHO BA DÒNG: mẫu lee duyệt hỏi câu này ở **hai chỗ** — thẻ xanh đáy
 *   thanh bên (*"Tủ AUTO-001 · đang nối · 2.1.0-beta1"*) và thẻ "Tủ gần nhất" ở cột ba của
 *   Tổng quan. Hai chỗ tự định nghĩa lấy là hai chỗ sẽ trôi khỏi nhau, và chỗ trôi sẽ là chỗ
 *   thanh bên nói một tủ còn Tổng quan nói một tủ khác — trên cùng một màn hình. (L67.)
 *
 * ⚠ "GẦN NHẤT" Ở ĐÂY LÀ **GẦN NHẤT VỀ THỜI GIAN**, không phải về khoảng cách địa lý. Hệ thống
 *   có `lat`/`lng` nên "gần nhất" đọc theo nghĩa không gian là một cách hiểu hoàn toàn hợp lý —
 *   và sai. Nói ra ở đây, một lần, thay vì để mỗi người đọc mã tự đoán.
 *
 * ⛔ KHÔNG có tủ nào ⇒ `null`, và chỗ gọi phải vẽ ca ấy. Trả một tủ giả hay tủ đầu danh sách
 *   là dựng một câu trả lời cho một câu hỏi chưa có dữ liệu — đúng luật `--chua-ro` của
 *   `thietke.css`: chưa đo được thì nói là chưa đo được.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
import type { TreeCabinet, TreeRoute } from './types';

/** Tủ kèm tuyến chứa nó — chỗ gọi thường cần cả hai để dựng đường dẫn và tên đầy đủ. */
export interface TuGanNhat {
  tu: TreeCabinet;
  tuyenId: string | null;
}

export function tuGanNhat(routes: readonly TreeRoute[] | undefined | null): TuGanNhat | null {
  if (!Array.isArray(routes) || routes.length === 0) return null;
  let tot: TuGanNhat | null = null;
  let mocTot = -1;
  for (const r of routes) {
    for (const c of r.cabinets ?? []) {
      /*
       * ⚠ `lastSeenAt` rỗng = tủ **chưa lên mạng lần nào**. Nó vẫn được xét (để một hệ thống
       *   toàn tủ mới vẫn có thứ để hiện), nhưng luôn thua bất kỳ tủ nào đã từng nối — `-1`
       *   thấp hơn mọi mốc thật, và `>` chứ không `>=` giữ tủ ĐẦU TIÊN khi hoà.
       */
      const moc = c.lastSeenAt ? new Date(c.lastSeenAt).getTime() : 0;
      if (Number.isFinite(moc) && moc > mocTot) {
        mocTot = moc;
        tot = { tu: c, tuyenId: r.id };
      }
    }
  }
  return tot;
}
